module.exports = __webpack_public_path__ + "static/media/dan-profile-alt.ddfbc7e4.png";